import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, Menu, X, Calendar } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_haul-away-pro/artifacts/lpx9fu7b_junkio.jpg" 
              alt="JUNKio Logo" 
              className="h-12 sm:h-14 w-auto"
            />
            <div className="flex flex-col">
              <span className="text-xs text-emerald-600 font-semibold">Licensed & Insured</span>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('home')} className="text-gray-700 hover:text-emerald-600 transition-colors font-medium">
              Home
            </button>
            <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-emerald-600 transition-colors font-medium">
              Services
            </button>
            <button onClick={() => scrollToSection('pricing')} className="text-gray-700 hover:text-emerald-600 transition-colors font-medium">
              Pricing
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-emerald-600 transition-colors font-medium">
              Contact
            </button>
            <Link to="/my-bookings" className="text-gray-700 hover:text-emerald-600 transition-colors font-medium flex items-center">
              <Calendar className="w-4 h-4 mr-1" />
              My Bookings
            </Link>
          </nav>

          {/* Contact Info */}
          <div className="hidden lg:flex items-center space-x-4">
            <a href="tel:3653363364" className="flex items-center text-emerald-600 hover:text-emerald-700 transition-colors">
              <Phone className="w-5 h-5 mr-2" />
              <span className="font-semibold">(365) 336-3364</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden text-gray-700 hover:text-emerald-600 transition-colors"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4">
              <button onClick={() => scrollToSection('home')} className="text-gray-700 hover:text-emerald-600 transition-colors font-medium text-left">
                Home
              </button>
              <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-emerald-600 transition-colors font-medium text-left">
                Services
              </button>
              <button onClick={() => scrollToSection('pricing')} className="text-gray-700 hover:text-emerald-600 transition-colors font-medium text-left">
                Pricing
              </button>
              <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-emerald-600 transition-colors font-medium text-left">
                Contact
              </button>
              <Link to="/my-bookings" onClick={() => setMobileMenuOpen(false)} className="text-gray-700 hover:text-emerald-600 transition-colors font-medium text-left flex items-center">
                <Calendar className="w-4 h-4 mr-2" />
                My Bookings
              </Link>
              <a href="tel:3653363364" className="flex items-center text-emerald-600 hover:text-emerald-700 transition-colors font-semibold">
                <Phone className="w-5 h-5 mr-2" />
                (365) 336-3364
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;